import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { BackOfficeService } from '../../../../../services/backoffice.service';

@Component({
  selector: 'app-route-schedule-duplicate',
  templateUrl: './route-schedule-duplicate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RouteScheduleDuplicateComponent {
  form: UntypedFormGroup;
  saving = false;
  error: string = null;

  constructor(
    private fb: UntypedFormBuilder,
    private backofficeService: BackOfficeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RouteScheduleDuplicateComponent>,
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      splitDate: ['', Validators.required],
      dateTo: ['', Validators.required]
    });
  }

  save() {
    if (!this.form.valid) return;

    const name = (this.form.value.name || '').trim();
    const splitDate = moment(this.form.value.splitDate).format('YYYY-MM-DD');
    const dateTo = moment(this.form.value.dateTo).format('YYYY-MM-DD');

    if (dateTo < splitDate) {
      this.error = 'End date must be on or after the start date';
      return;
    }

    this.error = null;
    this.saving = true;
    this.backofficeService.duplicateRouteScheduleTemplate(this.data.template?.id, name, splitDate, dateTo).subscribe({
      next: (response) => {
        this.saving = false;
        this.dialogRef.close({ success: true, template: response });
      },
      error: (err) => {
        this.saving = false;
        this.error = err?.error || 'Could not duplicate the template';
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
